import React from 'react';
import Gnb from '../components/Gnb';
import NotAvailableAppkey from '../components/ErrorContent/NotAvailableAppkey';
import Immutable from 'immutable';

const NotAvailableAppkeyPage = ({ device }) => (
  <div style={{ height: '100%' }}>
		<div id="kakaoWrap">
			<div id="kakaoHead" className="head_bridge" role="banner">
				<h1 className="tit_logo">
					<a href="#none" className="link_logo" style={{ padding: 0 }}>
            <span className="ico_plus ico_logo">카카오톡 채널</span>
          </a>
				</h1>
			</div>
			<hr className="hide" />
			{/* 톡연동 : .cont_inter */}
			<NotAvailableAppkey />
		</div>
  </div>
)

export default NotAvailableAppkeyPage;



// WEBPACK FOOTER //
// ./src/containers/NotAvailableAppkeyPage.js